import { Document, Page, StyleSheet, Font } from "@react-pdf/renderer";
import ReceiptTitle from "./ReceiptTitle";
import ReceiptItemsTable from "./ReceiptItemsTable";
import { SummaryDto } from "../../app/models/summary/summaryDto";
import ReceiptHeader from "./ReceiptHeader";
import ReceiptFooter from "./ReceiptFooter";
import ReceiptItems from "./ReceiptItems";
import { PCSDetailsDto } from "../../app/models/pcsEnrolment/pcsDetailsDto";
import { Scheme } from "../../app/models/staticData/scheme";
import { RegistrationType } from "../../app/models/staticData/registrationType";
import { useEffect, useState } from "react";
import LegacyReceiptItemsTable from "./LegacyReceiptItemsTable";
import LegacyReceiptTitle from "./LegacyReceiptTitle";
import LegacyReceiptItems from "./LegacyReceiptItems";

Font.register({
    family: 'Open Sans',
    fonts: [
        { src: 'https://cdn.jsdelivr.net/npm/open-sans-all@0.1.3/fonts/open-sans-regular.ttf' },
        { src: 'https://cdn.jsdelivr.net/npm/open-sans-all@0.1.3/fonts/open-sans-600.ttf', fontWeight: 600 },
        { src: 'https://cdn.jsdelivr.net/npm/open-sans-all@0.1.3/fonts/open-sans-700.ttf', fontWeight: 700 },
        { src: 'https://cdn.jsdelivr.net/npm/open-sans-all@0.1.3/fonts/open-sans-800.ttf', fontWeight: 800 }
    ]
});

const styles = StyleSheet.create({
    body: {
        paddingTop: 35,
        paddingBottom: 65,
        paddingHorizontal: 35,
        fontFamily: 'Helvetica'
    }
});

interface Props {
    summaryTitles: string[] | null;
    summaryData: SummaryDto[][] | null;
    legacyTitles: string[] | null;
    legacySummaryData: SummaryDto[][] | null;
    registrationDetails: PCSDetailsDto | null;
    schemes: Scheme[] | null;
    registrationTypes: RegistrationType[] | null;
    personName: string;
}

export default function PdfDocument({ summaryTitles, summaryData, legacyTitles, legacySummaryData,
    registrationDetails, schemes, registrationTypes, personName }: Props) {
    const [isYearPartialyCompleted, setIsYearPartialyCompleted] = useState<boolean>(false);
    const [isLegacyYearPartialyCompleted, setIsLegacyYearPartialyCompleted] = useState<boolean>(false);

    useEffect(() => {
        if (summaryData) {
            summaryData.map((item: SummaryDto[]) => {
                if (item[2].text.toLowerCase() === "true") {
                    setIsYearPartialyCompleted(true);
                }
            });
        }
    }, [summaryData]);

    useEffect(() => {
        if (legacySummaryData) {
            legacySummaryData.map((item: SummaryDto[]) => {
                if (item[1].text.toLowerCase() === "true") {
                    setIsLegacyYearPartialyCompleted(true);
                }
            });
        }
    }, [legacySummaryData]);

    return (
        <>
            <Document>
                <Page style={styles.body}>
                    <ReceiptHeader registrationDetails={registrationDetails} schemes={schemes} />
                    <ReceiptTitle />
                    {summaryData && summaryData?.length > 0 && <>
                        <ReceiptItems summaryData={summaryData} registrationDetails={registrationDetails} schemes={schemes}
                            registrationTypes={registrationTypes} personName={personName} />
                        <ReceiptItemsTable summaryTitles={summaryTitles} summaryData={summaryData} />
                        <ReceiptFooter isYearPartialyCompleted={isYearPartialyCompleted} />
                    </>}
                    {legacySummaryData && legacySummaryData.length > 0 && <>
                        {summaryData?.length === 0 && <LegacyReceiptItems registrationDetails={registrationDetails} schemes={schemes}
                            registrationTypes={registrationTypes} personName={personName} />}
                        <LegacyReceiptTitle />
                        <LegacyReceiptItemsTable legacyTitles={legacyTitles} legacySummaryData={legacySummaryData} />
                        <ReceiptFooter isYearPartialyCompleted={isLegacyYearPartialyCompleted} />
                    </>}
                </Page>
            </Document >
        </>)
}
